import { useState } from 'react';

import { Grid } from '@mui/material';

import { PlanTableTopBar } from './components/plan-table-top-bar';
import { PlanTable } from './components/plan-table';
import { PlanModal } from './components/plan-modal';

import { PlanModalState } from './components/plan-modal/utils';

import { planStyles } from './styles';

import { PaymentPlan } from 'utils/types';

export const Plans = () => {
  const [planModal, setPlanModal] = useState<PlanModalState | null>(null);

  const handleAddPlan = () => setPlanModal({ mode: 'create' });

  const handleEditPlan = (plan: PaymentPlan) => setPlanModal({ mode: 'edit', plan });

  const handlePlanModalClose = () => setPlanModal(null);

  return (
    <Grid sx={planStyles.container}>
      <PlanTableTopBar onAddPlan={handleAddPlan} />
      <PlanTable onEditPlan={handleEditPlan} />
      {planModal && <PlanModal open modalState={planModal} handleClose={handlePlanModalClose} />}
    </Grid>
  );
};
